import type { DeepRequired } from '../fixtures.types'

const commissionStructure: DeepRequired<CommissionStructureResponse> = {
  __typename: 'CommissionStructureResponse',
  commission_structures: [],
  next_page: {
    __typename: 'CommissionStructureRequest',
    filter_paying_organisation_id: null,
    commission_structure_ids: [],
    filter_receiving_organisation_id: null,
    filter_receiving_user_id: null,
    bookmark: 1,
    page_size: 1,
  },
}

export default commissionStructure
